import { useState } from 'react'
import { useAccessibility } from '../../context/AccessibilityContext/AccessibilityContext'
import style from './achievementcard.module.scss'

const AchievementCard = ({width, image, title, onClick}) => {
    const { settings: { contrast } } = useAccessibility()
    
    const config = {
        width: width || '90%',
        '--card-bg': contrast !== 'default' ? 'var(--bg-primary)' : '#fff',
        '--text-color': contrast !== 'default' ? 'var(--text-primary)' : '#272b37'
    }

    const handleKeyPress = (e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onClick();
        }
    };

    return (
        <div
            className={style.achievementcard}
            style={config}
            onClick={onClick}
            onKeyDown={onClick ? handleKeyPress : undefined}
            tabIndex={onClick ? 0 : -1}
            role={onClick ? 'button' : 'article'}
            aria-label={`Подробнее о достижении: ${title}`}
        >
            <div className={style.wrapper}>
                <img
                    className={`${style.image} keep-image`}
                    src={image}
                    alt={title}
                    loading="lazy"
                />
                <span className={style.text}>
                    {title}
                </span>
            </div>
        </div>
    )
}

export default AchievementCard